import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const ProjectTemplates = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.project-templates.title"
                    defaultMessage="Project templates"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.project-templates.bodyOne"
                    defaultMessage="Choose from a wide selection of project templates based on your team function or use case. Templates include pre-configured issue types, workflows, and other relevant features to help teams get started quickly."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.project-templates.learnMore"
                    defaultMessage="Explore the <learnMore>Jira template library</learnMore>."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/templates"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default ProjectTemplates;
